import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { loginPathFor } from 'utils/safeRedirect'

interface PrivateRouteProps {
	children: React.ReactNode
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
	const location = useLocation()
	const userLogin = useSelector((state: any) => state.userLogin)
	const isLoggedIn = userLogin.userInfo !== null && userLogin.userInfo !== undefined

	if (!isLoggedIn) {
		// Remember the page, so signing in lands there (MYD-541).
		return <Navigate to={loginPathFor(location)} replace />
	}

	return <>{children}</>
}

export default PrivateRoute
